export default {"src":"/_next/static/media/vwgif.9b513173.gif","height":476,"width":564,"blurWidth":0,"blurHeight":0};